import { render } from "./FormIngreso.vue?vue&type=template&id=24f13061"
import script from "./FormIngreso.vue?vue&type=script&lang=js"
export * from "./FormIngreso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__